import React from 'react';
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import {Trans} from "react-i18next";
import {Link} from "react-router-dom";
import classNames from "classnames";
import InputContainer from "../../forms/hookfields/InputContainer";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {COUNTRIES} from "../../../constants/countries";
import InputMask from 'react-input-mask';
import {addUserToCompanyByNRN} from "../../../services/api/users";
import {selectCompany} from "../../../redux/preferences/selectors";
import {selectUser} from "../../../redux/auth/selectors";
import {connect} from "react-redux";
import {ajaxErrorHandler, defaultError, defaultSuccess} from "../../../libs/utils";

const breadcrumbs = [
    {
        title: "Employees",
        to: "/company/employees"
    }
];

const schema = yup.object().shape({
    nationality: yup
        .string()
        .required(),
    nationalRegistryNumber: yup
        .string()
        .required()
});


const _CompanyEmployeesNin = ({company, history}) => {
    const isSubmitting = false;

    const onSubmit = values => {
        addUserToCompanyByNRN(company.id, values)
            .then(companyUser => {
                defaultSuccess(
                    `${companyUser.user.firstName} ${companyUser.user.lastName} has been added to ${company.name}.`
                );
                reset();
            })
            .catch(error => {
                console.error(error);
                if(error.response.status === 404){
                    console.log("user not found")
                    history.push(`/company/employees/create?nationality=${values.nationality}&nationalRegistryNumber=${values.nationalRegistryNumber}`);
                    return;
                }
                if (error.response.status === 422) {
                    defaultError(error.response.data.message);
                    return;
                }
                ajaxErrorHandler(error);
            });
    };

    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
        reset
    } = useForm({
        defaultValues: {
            nationality: "",
            nationalRegistryNumber: ""
        },
        resolver: yupResolver(schema)
    });
    const watchNationality = watch("nationality")

    return (
        <>
            <AdminSubHeader
                title={"Lookup Employee"}
                breadcrumbs={breadcrumbs}
            />
            <div className="m-content" key="content">
                <div className="alert alert-info">
                    <Trans>National Identification Number Explanation</Trans>
                </div>
                <div className="row">
                    <div className={"col-xl-6 offset-xl-3"}>
                        <div className="m-portlet">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                          <i className="flaticon-information" />
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>Employee Info</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <form
                                className="m-login__form m-form"
                                onSubmit={handleSubmit(onSubmit)}
                            >
                                <div className="m-portlet__body">
                                    <InputContainer errors={errors} label={"Nationality"} required={true} name={"nationality"}>
                                        <select
                                            name="nationality"
                                            id="nationality"
                                            className="form-control m-input"
                                            {...register("nationality")}

                                        >
                                            <option value="" disabled selected>Select Nationality</option>
                                            <option value="BE">Belgium</option>
                                            <option value="NL">Netherlands (the)</option>
                                            {COUNTRIES.map(country => (
                                                <option value={country.value}>{country.label}</option>
                                            ))}
                                        </select>
                                    </InputContainer>

                                    {watchNationality && (
                                        <InputContainer errors={errors} label={"National Identification Number"} required={true} name={"nationalRegistryNumber"}>
                                            <>
                                                {watchNationality === "BE" && (
                                                    <Controller
                                                        control={control}
                                                        name="nationalRegistryNumber"
                                                        render={({ field: { onChange, onBlur, value } }) => (
                                                            <InputMask
                                                                mask="99.99.99-999.99"
                                                                className="form-control m-input"
                                                                onBlur={onBlur}
                                                                onChange={onChange}
                                                                defaultValue={value}
                                                            />
                                                        )}
                                                    />
                                                )}

                                                {watchNationality === "NL" && (
                                                    <Controller
                                                        control={control}
                                                        name="nationalRegistryNumber"
                                                        render={({ field: { onChange, onBlur, value } }) => (
                                                            <InputMask
                                                                mask="999999999"
                                                                className="form-control m-input"
                                                                onBlur={onBlur}
                                                                onChange={onChange}
                                                                defaultValue={value}
                                                            />
                                                        )}
                                                    />

                                                )}

                                                {watchNationality === "FR" && (
                                                  <Controller
                                                    control={control}
                                                    name="nationalRegistryNumber"
                                                    render={({ field: { onChange, onBlur, value } }) => (
                                                      <InputMask
                                                        mask="999999999999999"
                                                        className="form-control m-input"
                                                        onBlur={onBlur}
                                                        onChange={onChange}
                                                        defaultValue={value}
                                                      />
                                                    )}
                                                  />
                                                )}

                                                {watchNationality !== "BE" && watchNationality !== "NL" && watchNationality !== "FR" && (
                                                    <input
                                                        className="form-control m-input"
                                                        type="text"
                                                        name="nationalRegistryNumber"
                                                        id="nationalRegistryNumber"
                                                        {...register("nationalRegistryNumber")}
                                                    />
                                                )}
                                            </>

                                        </InputContainer>
                                    )}


                                </div>
                                <div className="m-portlet__foot">
                                    <div className="row align-items-center">
                                        <div className="col-lg-12 m--align-right">
                                            <button
                                                className={
                                                    classNames(
                                                        "btn m-btn btn-secondary m--margin-left-10",
                                                        {"m-btn--custom m-loader m-loader--light m-loader--left": isSubmitting}
                                                    )
                                                }
                                                disabled={isSubmitting}
                                            >
                                                <Trans>Search</Trans>
                                            </button>
                                            <span className="m--margin-left-10">
                                                <Trans>or</Trans>{" "}
                                                <Link
                                                    to="/company/employees"
                                                    className="m-link m--font-bold"
                                                >
                                                    <Trans>Cancel</Trans>
                                                </Link>
                                          </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = function(state) {
    return {
        company: selectCompany(state),
        user: selectUser(state)
    };
};

const CompanyEmployeesNin = connect(
    mapStateToProps
)(_CompanyEmployeesNin);

export default CompanyEmployeesNin;
